<div>
  <div class="container-fluid">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h2 class="mb-0">
        <i class="bi bi-award me-2"></i>
        Sponsors
      </h2>
      <button class="btn btn-primary" (click)="toggleAddForm()">
        <i class="bi" [class.bi-plus-lg]="!showAddForm" [class.bi-x-lg]="showAddForm"></i>
        {{ showAddForm ? 'Cancel' : 'Add Sponsor' }}
      </button>
    </div>

    <!-- Add Sponsor Form -->
    <div *ngIf="showAddForm" class="card mb-4">
      <div class="card-header">
        <h5 class="mb-0">New Sponsor</h5>
      </div>
      <div class="card-body">
        <div *ngIf="addError" class="alert alert-danger py-2 mb-3">
          {{ addError }}
        </div>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Name *</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newSponsor.name"
              placeholder="Sponsor name"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label">Website</label>
            <input
              type="url"
              class="form-control"
              [(ngModel)]="newSponsor.website"
              placeholder="https://..."
            />
          </div>
          <div class="col-md-3">
            <label class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              [(ngModel)]="newSponsor.email"
              placeholder="contact@..."
            />
          </div>
          <div class="col-md-3">
            <label class="form-label">Phone</label>
            <input
              type="tel"
              class="form-control"
              [(ngModel)]="newSponsor.phone"
              mask="(000) 000-0000"
              [validation]="false"
              placeholder="(555) 555-5555"
            />
          </div>
        </div>
        <div class="mt-3">
          <button
            class="btn btn-primary btn-sm"
            (click)="submitNewSponsor()"
            [disabled]="addingSponsors"
          >
            <span *ngIf="addingSponsors" class="spinner-border spinner-border-sm me-1" role="status"></span>
            {{ addingSponsors ? 'Creating...' : 'Create Sponsor' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ errorMessage }}
      <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
    </div>

    <!-- Search -->
    <div class="card mb-4">
      <div class="card-body py-3">
        <div class="row g-3 align-items-center">
          <div class="col-md-6">
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-search"></i>
              </span>
              <input
                type="text"
                class="form-control"
                placeholder="Search sponsors..."
                [(ngModel)]="searchQuery"
                (keyup.enter)="onSearch()"
              />
              <button
                *ngIf="searchQuery"
                class="btn btn-outline-secondary"
                (click)="clearSearch()"
                type="button"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
          <div class="col-md-6 text-md-end">
            <span class="text-muted">
              {{ totalSponsors }} sponsor{{ totalSponsors === 1 ? '' : 's' }} found
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Sponsors Table -->
    <div class="card" *ngIf="!loading">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th>Logo</th>
              <th>Name</th>
              <th>Brand Color</th>
              <th>Website</th>
              <th>Email</th>
              <th>Phone</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let sponsor of sponsors"
              (click)="viewSponsor(sponsor)"
              class="cursor-pointer"
            >
              <td>
                <div
                  class="entity-avatar entity-avatar-square overflow-hidden p-1"
                  [class.border]="!sponsor.brandColor"
                  [style.background-color]="sponsor.brandColor || null"
                >
                  <img
                    *ngIf="sponsor.logoUrl"
                    [src]="getLogoFullUrl(sponsor.logoUrl)"
                    [alt]="sponsor.name"
                    class="mw-100 mh-100 object-fit-contain"
                  />
                  <i *ngIf="!sponsor.logoUrl" class="bi bi-image text-body-secondary small"></i>
                </div>
              </td>
              <td class="fw-medium">{{ sponsor.name }}</td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <div
                    *ngIf="sponsor.brandColor"
                    class="d-inline-block p-2 rounded-1 border flex-shrink-0"
                    [style.background-color]="sponsor.brandColor"
                  ></div>
                  <span class="small">{{ sponsor.brandColor || '-' }}</span>
                </div>
              </td>
              <td>
                <a *ngIf="sponsor.website" [href]="sponsor.website" target="_blank" rel="noopener" (click)="$event.stopPropagation()">
                  {{ sponsor.website }}
                </a>
                <span *ngIf="!sponsor.website" class="text-muted">-</span>
              </td>
              <td>{{ sponsor.email || '-' }}</td>
              <td>{{ (sponsor.phone | phoneFormat) || '-' }}</td>
              <td class="text-end">
                <button
                  class="btn btn-outline-danger btn-sm"
                  (click)="archiveSponsor(sponsor, $event)"
                  title="Archive sponsor"
                >
                  <i class="bi bi-archive"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty State -->
      <div *ngIf="sponsors.length === 0 && !loading" class="text-center py-5">
        <i class="bi bi-building fs-1 text-muted d-block mb-3"></i>
        <p class="text-muted">No sponsors found</p>
      </div>

      <!-- Pagination -->
      <div *ngIf="totalPages > 1" class="card-footer d-flex align-items-center justify-content-between">
        <span class="text-muted small">
          Showing {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalSponsors) }} of {{ totalSponsors }}
        </span>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link" (click)="goToPage(currentPage - 1)">
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            <li
              *ngFor="let page of paginationRange"
              class="page-item"
              [class.active]="page === currentPage"
            >
              <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button class="page-link" (click)="goToPage(currentPage + 1)">
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
